import React from 'react';
import {connect} from "react-redux";
import LoadingComponent from "../components/LoadingComponent";
import RewardExpiredComponent from "../components/RewardExpiredComponent";
import RewardOutOfStockComponent from "../components/RewardOutOfStockComponent";
import RewardAccountLimitReachedComponent from "../components/RewardAccountLimitReachedComponent";
import RewardClaimOptionsNotFoundComponent from "../components/RewardClaimOptionsNotFoundComponent";
import ClaimRewardComponent from "../components/ClaimRewardComponent"
import ErrorComponent from "../components/ErrorComponent";

class RewardDetailContainer extends React.Component {

    componentWillMount() {
        this.props.fetchRewardClaimOptions(this.props.friendlyName);
    }

    render() {
        if(this.props.rewardClaimOptions === null) {
            return this.props.error ? <RewardClaimOptionsNotFoundComponent/> : <LoadingComponent/>;
        }else {
            let claimFailedErrorComponent = null;
            if(this.props.claimFailedError !== null)
                claimFailedErrorComponent = <ErrorComponent messageKey="reward.claim.failed"/> ;

            let correctComponent = null;

            if (this.props.rewardClaimOptions.expired) {
                correctComponent = <RewardExpiredComponent/>
            } else if (!this.props.rewardClaimOptions.stockLeft) {
                correctComponent = <RewardOutOfStockComponent/>
            } else if (this.props.rewardClaimOptions.amountAvailableForUser <= 0) {
                correctComponent = <RewardAccountLimitReachedComponent/>
            } else {
                correctComponent = <ClaimRewardComponent maxAmount={this.props.rewardClaimOptions.amountAvailableForUser}
                                                         claimReward={this.props.claimReward}
                                                         friendlyName={this.props.friendlyName}
                                                         showRewardClaimedDescription={this.props.rewardClaimOptions.showRewardClaimedDescription}
                                                         rewardClaimedDescription={this.props.rewardClaimedDescription}
                                                         integratorType={this.props.rewardClaimOptions.integratorType}
                                                         url={this.props.rewardClaimOptions.url}
                                                         claimRewardByRedirect={this.props.claimRewardByRedirect}
                                                         showClaimButton={this.props.rewardClaimOptions.redirectUrlButtonVisible}/>
            }
            return <div>{claimFailedErrorComponent} {correctComponent} </div>
        }
    }
}

export default connect (
    (state) => {
        return {
            rewardClaimOptions: state.rewardClaimOptions.item,
            error: state.rewardClaimOptions.error,
            claimFailedError: state.claimReward.error,
            rewardClaimedDescription: state.reward.item ? state.reward.item.rewardClaimedDescription : null
        }
    },
    (dispatch) => {
        return {
            fetchRewardClaimOptions: (friendlyName) => {
                dispatch({
                    type: 'FETCH_REWARD_CLAIM_OPTIONS',
                    friendlyName
                })
            },
            claimReward: (friendlyName, amount) => {
                dispatch({
                    type: 'CLAIM_REWARD',
                    data: {
                        friendlyName: friendlyName,
                        amount: amount
                    }
                })
            },
            claimRewardByRedirect: () => {
                dispatch({
                    type: 'CLAIM_REWARD_REDIRECT'
                })
            }
        }
    }
) (RewardDetailContainer)